import React from 'react';
import { Link } from 'react-router-dom';
import { Search, ArrowRight } from 'lucide-react';
import { mockOffers } from '../data/mockData';
import { OfferCard } from '../components/OfferCard';
export function HomePage() {
  // Featured offers (first 3)
  const featuredOffers = mockOffers.slice(0, 3);
  return <div className="min-h-screen bg-white pb-32 md:pb-32" data-id="element-346">
      {/* Animated Hero Section */}
      <div className="relative min-h-[70vh] md:h-[80vh] w-full overflow-hidden bg-gradient-to-b from-gray-50 to-white flex flex-col items-center justify-center text-center px-4 py-12" data-id="element-347">
        {/* Floating Background Images - All 5 images visible on mobile and desktop */}
        <div className="absolute inset-0 pointer-events-none opacity-30 md:opacity-40" data-id="element-348">
          {/* Top Left */}
          <img src="https://images.unsplash.com/photo-1489987707025-afc232f7ea0f?w=400" className="absolute top-[10%] left-[5%] w-32 md:w-48 h-48 md:h-64 object-cover rounded-2xl shadow-xl animate-float-slow" alt="Clothing" data-id="element-349" />
          {/* Top Right */}
          <img src="https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=400" className="absolute top-[15%] right-[8%] w-28 md:w-40 h-28 md:h-40 object-cover rounded-full shadow-xl animate-float-medium" alt="Hearing Aid" data-id="element-350" />
          {/* Bottom Left */}
          <img src="https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=400" className="absolute bottom-[20%] left-[12%] w-40 md:w-56 h-32 md:h-40 object-cover rounded-2xl shadow-xl animate-float-fast" alt="Home Comfort" data-id="element-351" />
          {/* Bottom Right */}
          <img src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=400" className="absolute bottom-[15%] right-[10%] w-32 md:w-44 h-40 md:h-56 object-cover rounded-2xl shadow-xl animate-float-slow" alt="Medical Device" data-id="element-352" />
          {/* Center Top (Faded) */}
          <img src="https://images.unsplash.com/photo-1547592180-85f173990554?w=400" className="absolute top-[5%] left-1/2 transform -translate-x-1/2 w-24 md:w-32 h-24 md:h-32 object-cover rounded-full shadow-lg opacity-50 animate-float-medium" alt="Meal" data-id="element-353" />
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-4xl mx-auto animate-fade-in" data-id="element-354">
          <img src="https://cdn.magicpatterns.com/uploads/f8hQhXBXpF9otTMKZLScKo/Kithward_Logo_(1).png" alt="Kithward" className="h-16 md:h-24 mx-auto mb-6 md:mb-8 object-contain" data-id="element-355" />

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-serif font-medium text-gray-900 mb-4 md:mb-6 tracking-tight leading-tight px-4" data-id="element-356">
            Products made for{' '}
            <span className="italic text-kithward-700" data-id="element-357">seniors</span>.
          </h1>

          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-500 mb-8 md:mb-12 max-w-2xl mx-auto font-light px-4" data-id="element-358">
            Discover exclusive cash back rewards on adaptive clothing, hearing
            aids, and home safety essentials.
          </p>

          {/* Hero Search - Responsive */}
          <div className="bg-white p-1.5 md:p-2 rounded-full shadow-2xl border border-gray-100 flex items-center max-w-2xl mx-auto transform transition-transform hover:scale-[1.02]" data-id="element-359">
            <Search className="w-5 h-5 md:w-6 md:h-6 text-gray-400 ml-3 md:ml-4 flex-shrink-0" data-id="element-360" />
            <input type="text" placeholder="What are you shopping for today?" className="flex-1 bg-transparent border-none px-2 md:px-4 py-3 md:py-4 text-sm md:text-lg text-gray-800 placeholder-gray-400 focus:ring-0 focus:outline-none min-w-0" data-id="element-361" />
            <button className="bg-kithward-700 hover:bg-kithward-800 text-white px-4 md:px-8 py-3 md:py-4 rounded-full font-bold transition-colors shadow-md text-sm md:text-base flex-shrink-0" data-id="element-362">
              Search
            </button>
          </div>
        </div>
      </div>

      {/* Featured Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-363">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-8 md:mb-10 gap-4" data-id="element-364">
          <div data-id="element-365">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-gray-900 mb-2" data-id="element-366">
              Featured Offers
            </h2>
            <p className="text-gray-500 text-base md:text-lg" data-id="element-367">
              Hand-picked rewards just for you.
            </p>
          </div>
          <Link to="/explore" className="flex items-center text-kithward-700 font-bold hover:text-kithward-800 transition-colors text-sm md:text-base" data-id="element-368">
            View all <ArrowRight className="ml-2 w-4 h-4 md:w-5 md:h-5" data-id="element-369" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-370">
          {featuredOffers.map(offer => <OfferCard key={offer.id} offer={offer} data-id="element-371" />)}
        </div>
      </div>
    </div>;
}